__webpack_require__.p = "/assets/turbo/cc7a5bb1/lascanaat/_next/";